export default function EFXGuard(props: any) {
    return (
        <svg width="237" height="51" viewBox="0 0 237 51" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_4069_749)">
                <path
                    d="M134.243 26.339H117.01L122.231 6.80518H117.134L111.842 26.5479C111.14 29.1676 112.696 31.2937 115.316 31.2937H138.001L144.56 6.80518H139.463L134.243 26.339Z"
                    fill="currentColor"
                />
                <path
                    d="M198.677 21.617C201.297 21.617 203.992 19.4908 204.695 16.8711L206.118 11.551C206.821 8.92657 205.264 6.80518 202.644 6.80518H179.864L178.498 11.9022H200.993L199.754 16.5152H177.264L173.306 31.2937H178.27L180.861 21.617H187.358L194.439 31.2937H201.662L194.614 21.617H198.677Z"
                    fill="currentColor"
                />
                <path
                    d="M230.336 6.80518H211.428L204.865 31.2937H223.772C228.49 31.2937 233.335 27.4686 234.602 22.7512L236.586 15.3429C237.849 10.6256 235.048 6.80518 230.336 6.80518ZM229.733 22.3953C229.095 24.5523 227.167 26.0733 224.921 26.1919H211.158L214.988 11.9117H228.751C230.848 11.9117 232.073 13.6107 231.532 15.7084L229.733 22.3953Z"
                    fill="currentColor"
                />
                <path
                    d="M94.0541 6.80518C89.3368 6.80518 84.4866 10.6018 83.2242 15.3477L81.2404 22.7559C79.9732 27.4733 82.7733 31.2985 87.4907 31.2985H106.393L110.351 16.5341H105.392L102.806 26.1967H89.0426C86.9449 26.1967 85.7205 24.4929 86.2662 22.4L88.0602 15.7036C88.6971 13.5458 90.6256 12.0242 92.8724 11.907H111.566L112.933 6.80518H94.0541Z"
                    fill="currentColor"
                />
                <path d="M159.619 6.7998L140.317 31.2883H145.932L160.682 12.5802L165.399 31.2883H171.013L164.839 6.7998H159.619Z" fill="currentColor" />
                <path d="M62.8885 21.5937H76.5898L77.9518 16.5015H64.2553L62.8885 21.5937Z" fill="currentColor" />
                <path d="M34.0958 0.179688H20.2853L32.3492 16.5101L41.1575 9.72832L34.0958 0.179688Z" fill="currentColor" />
                <path d="M48.1817 37.9094H61.9968L50.9248 22.9268L41.3951 28.7309L48.1817 37.9094Z" fill="currentColor" />
                <path
                    d="M74.6485 0.179688H57.293L27.2803 23.197H33.8533L0.68457 51.0029L57.5018 16.4911H50.8576L74.6485 0.179688Z"
                    fill="url(#paint0_linear_4069_749)"
                />
            </g>
            <defs>
                <linearGradient id="paint0_linear_4069_749" x1="70.5576" y1="0.179687" x2="0.802729" y2="50.9631" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
                <clipPath id="clip0_4069_749">
                    <rect width="236.205" height="50.8232" fill="currentColor" transform="translate(0.68457 0.179688)" />
                </clipPath>
            </defs>
        </svg>
    );
}
